<div [ngClass]="{'ds-score' : size !== 'l', 'db-with-shadow': withShadow}">
  <div class="ds-score-circle-wrap {{size}}" [ngClass]="{'db-with-shadow': withShadow}" *ngIf="!loading && !error">
    <div class="ds-score-number"
         [ngClass]="{
         'yellow': score >= 50 && score < 90,
         'red': score >= 0 &&  score < 50 }"><span>{{score}}</span></div>
    <svg viewBox="0 0 40 40">
      <circle class="ds-score-stroke-bg"
              [ngClass]="{'db-score-stroke-yellow': score >= 50 && score < 90,
                  'db-score-stroke-red': score >= 0 && score < 50 }"
              r="18" cx="20" cy="20"></circle>
      <circle class="ds-score-stroke" [ngStyle]="{'stroke-width': lineWidth + 'px'}"
              [class.thin]="thin"
              [ngClass]="{'db-score-stroke-yellow': score >= 50 && score < 90,
                  'db-score-stroke-red': score >= 0 && score < 50 }"
              transform="rotate(-90 20 20)" r="18" cx="20" cy="20"
              attr.stroke-dasharray="{{radius - (radius * (1-((score) / 100)))}}, {{radius}}"></circle>
    </svg>
  </div>

  <div class="ds-score-circle-wrap {{size}} spinner" *ngIf="loading">
    <img src="assets/images/google/google_spinner.svg" alt=""/>
  </div>

  <div class="ds-score-circle-wrap {{size}} error" *ngIf="!loading && error">
    <i class="db-icon db-icon-ds-exclamation-bg"></i>
  </div>
</div>
